import { PermissionNew } from "../type";

export const getUniqueColumns = (permissions: PermissionNew[]): string[] => {
  const columnsSet = new Set<string>();

  permissions.forEach((perm) => {
    columnsSet.add(perm.displayName);
  });

  return Array.from(columnsSet);
};
